<template>
  <v-card-actions class="action-buttons-container">
    <slot></slot>
    <v-tooltip bottom class="action-buttons" v-if="images.length && showImages">
      <v-btn small icon flat color="#293968" slot="activator">
        <v-icon color="primary lighten-2" @click="showCarousel">photo_library</v-icon>
      </v-btn>
      <span>Imágenes</span>
      <Carousel ref="carousel" :attachments="images"></Carousel>
    </v-tooltip>
    <v-tooltip bottom class="action-buttons" v-if="documents.length">
      <v-btn small icon flat color="#293968" slot="activator">
        <v-icon color="primary lighten-2" @click="showDocuments">picture_as_pdf</v-icon>
      </v-btn>
      <span>{{ getTooltipForDocument() }}</span>
      <Documents ref="docs" :attachments="documents"></Documents>
    </v-tooltip>
    <v-tooltip bottom class="action-buttons" v-if="allowed && requerimiento.requirementSubareaPermission && !requerimiento.criterionIsCargaLpf">
      <v-btn small icon flat color="#293968" slot="activator">
        <v-icon color="primary lighten-2" @click="showEdit = true">edit</v-icon>
      </v-btn>
      <span>Editar</span>
      <RequerimientoEdit ref="edit" :requerimiento="requerimiento" @updateRequerimiento="updateAfterRequest"
                         @hideDialog="hideEdit" v-if="showEdit"></RequerimientoEdit>
    </v-tooltip>
  </v-card-actions>
</template>

<script>
import Carousel from '../../../common/ui/Carousel.vue'
import Constants from '../../../common/constants'
import Documents from '../../../common/ui/AttachmentsLinksPreview.vue'
import RequerimientoEdit from '../components/RequerimientoEdit.vue'

export default {
  props: {
    requerimiento: Object,
    allowed: Boolean,
    attachmentsPropertyName: {
      type: String,
      default: 'adjuntos'
    },
    showImages: Boolean
  },

  data () {
    return {
      showEdit: false
    }
  },

  components: {
    Carousel,
    Documents,
    RequerimientoEdit
  },

  computed: {
    images () {
      return this.requerimiento[this.attachmentsPropertyName].filter(item => this.isImage(item.asset.name))
    },
    documents () {
      return this.requerimiento[this.attachmentsPropertyName].filter(item => !this.isImage(item.asset.name))
    },
    hasOnlyOneDocument () {
      return this.documents.length === 1
    }
  },

  methods: {
    showCarousel () {
      this.$refs.carousel.showDialog()
    },
    isImage (fileName) {
      return fileName.toLowerCase().match(Constants.ALLOWED_IMAGE_EXTENSIONS) != null
    },
    showDocuments () {
      if (this.hasOnlyOneDocument) {
        window.open(this.documents[0].asset.url, '_blank')
      } else {
        this.$refs.docs.showDialog()
      }
    },
    hideEdit () {
      this.showEdit = false
    },
    updateAfterRequest (response) {
      this.$emit('updateRequerimiento', response)
    },
    getTooltipForDocument () {
      if (this.hasOnlyOneDocument) {
        let description = this.documents[0].asset.description
        return (description) ? `Abrir documento: ${description}` : 'Abrir documento en una nueva pestaña'
      }
      return 'Documentos'
    }
  },

  created () {
    this.requerimiento.allowed = 'user'
  }
}
</script>

<style scoped>
.action-buttons {
  margin: 0 0 0 0;
  width: 1.8em;
  height: 1.8em;
}
.action-buttons-container {
  padding: 0;
  margin: 0;
}
</style>
